import _ from 'lodash'

import {
  SET_ACTIVE_ACCOMMODATION,
  RESET_ACTIVE_ACCOMMODATION,
} from '../actions/setActiveAccommodation'

const initialState = null

export default function activeAccommodation(state = initialState, action) {
  switch (action.type) {
    case SET_ACTIVE_ACCOMMODATION: {
      return action.payload
    }
    case RESET_ACTIVE_ACCOMMODATION: {
      return null
    }
    default:
      return state
  }
}

export const getActiveAccommodation = (state) =>
  _.get(state, 'activeAccommodationData')
